import { Popover, Typography, Grid, Switch, Box } from '@mui/material';
import { lighten, darken } from '@mui/system';
import PropTypes from 'prop-types';

const AlertPopover = ({
  anchorEl,
  handleClose,
  chatAlertEnabled,
  alertSoundEnabled,
  handleToggleChange,
  activatedStates,
  notificationPermission,
}) => {
  return (
    <Popover
      id={anchorEl ? 'alert-popover' : undefined}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      PaperProps={{
        style: { padding: '20px', maxWidth: '400px' },
      }}
    >
      <Typography variant="h6" gutterBottom>
        Alertas de chats
      </Typography>
      <Grid container alignItems="center" spacing={1}>
        <Grid item>
          <Switch
            checked={chatAlertEnabled}
            onChange={(e) => handleToggleChange('isChatAlertsEnabled', e.target.checked)}
            color="primary"
          />
        </Grid>
        <Grid item>
          <Typography variant="body2" gutterBottom>
            Alertas de chats {chatAlertEnabled ? 'activadas' : 'desactivadas'}
          </Typography>
        </Grid>
      </Grid>
      <Grid container alignItems="center" spacing={1}>
        <Grid item>
          <Switch
            checked={alertSoundEnabled}
            onChange={(e) => handleToggleChange('isSoundAlertsEnabled', e.target.checked)}
            color="primary"
          />
        </Grid>
        <Grid item>
          <Typography variant="body2" gutterBottom>
            Sonido {alertSoundEnabled ? 'activado' : 'desactivado'}
          </Typography>
        </Grid>
      </Grid>
      <Typography
        variant="body2"
        style={{
          marginTop: '5px',
          marginBottom: '5px',
          fontStyle: 'italic',
          color: notificationPermission === 'granted' ? 'green' : 'red',
        }}
      >
        {notificationPermission === 'granted'
          ? 'Permisos de notificaciones de sistema OK 😊'
          : notificationPermission === 'denied'
          ? 'Permisos de notificaciones de sistema denegados 😢'
          : notificationPermission === 'isNotIOSSupported'
          ? 'Notificaciones no soportadas 😢'
          : 'Permisos de notificaciones de sistema sin configurar 😵‍💫'}
      </Typography>
      <Typography variant="body1" style={{ marginBottom: '4px' }}>
        Alertas para los estados:
      </Typography>
      <Grid container spacing={2} style={{ marginTop: '2px' }}>
        {activatedStates?.map((state, index) => (
          <Grid item xs={6} key={index} style={{ paddingTop: '6px' }}>
            <Box
              sx={{
                backgroundColor: lighten(state?.color || '#FFFFFF', 0.6),
                borderRadius: 2,
                padding: '4px',
                textAlign: 'center',
              }}
            >
              <Typography variant="body2" sx={{ color: darken(state?.color || '#000000', 0.5) }}>
                {state
                  ? state?.label?.charAt(0).toUpperCase() + state?.label?.slice(1)
                  : 'Desconocido'}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Popover>
  );
};

AlertPopover.propTypes = {
  anchorEl: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  chatAlertEnabled: PropTypes.bool.isRequired,
  alertSoundEnabled: PropTypes.bool.isRequired,
  handleToggleChange: PropTypes.func.isRequired,
  activatedStates: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  notificationPermission: PropTypes.oneOf(['granted', 'denied', 'default', 'isNotIOSSupported'])
    .isRequired,
};
export default AlertPopover;
